import React, { useEffect, useState } from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import { NotificationManager } from "react-notifications";
import DatePicker from "react-datepicker";
import { InventarioInicialApi } from "../api/InventarioInicialApi";
import LoadMask from "../../../../../Utils/LoadMask/LoadMask";
import { AlmacenesTable } from "./AlmacenesTable";
import {
    dateToDayStart,
    getErrorFromResponse,
} from "../../../../../../../utility/utils";
import moment from "moment";

import Swal from "sweetalert2";
const alerta = require("assets/img/icons/alerta_roja.png");

export const ListadoAlmacenes = ({ regresar, nombreAcopio }) => {
    const [almacenes, setAlmacenes] = useState([]);

    const { getInventariosIniciales, upsertInventariosIniciales, cargando } =
        InventarioInicialApi();

    const [fechaInicial, setFechaInicial] = useState(null);

    const GetInventariosIniciales = async () => {
        try {
            const response = await getInventariosIniciales();
            if (response) {
                setAlmacenes(response.almacenes || []);
                setFechaInicial(
                    response.fecha_inicial
                        ? moment(response.fecha_inicial)
                        : null,
                );
            }
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener almacenes disponibles",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setAlmacenes([]);
        }
    };

    useEffect(() => {
        GetInventariosIniciales();
    }, []);

    const ValidateAndSubmit = () => {
        if (!fechaInicial) {
            NotificationManager.warning(
                "Debes seleccionar una fecha inicial",
                "Validación",
                3000,
            );
            return false;
        }

        const isNullOrUndefined = (value) =>
            value === null || value === undefined;

        const datosVacios = almacenes.some(
            (item) =>
                isNullOrUndefined(item.kg_secos_laboratorio) ||
                isNullOrUndefined(item.kg_secos_liquidacion),
        );

        if (datosVacios) {
            MostrarAlertaDatosVacios();
        } else {
            ActualizarInventariosIniciales();
        }
    };

    const MostrarAlertaDatosVacios = () => {
        const SwalMod = Swal.mixin({
            customClass: {
                confirmButton: "btn btn-primary",
                cancelButton: "btn btn-outline-dark mr-5",
                content: "d-flex justify-content-center mb-4",
                title: "verde-primario",
                image: "blink-danger",
            },
            buttonsStyling: false,
            focusConfirm: false,
            focusCancel: false,
        });
        SwalMod.fire({
            title: "¡ADVERTENCIA!",
            text: "Hay pesos que han quedado vacíos. ¿Deseas guardarlos como 0?",
            imageUrl: alerta,
            imageAlt: "Alerta",
            showCancelButton: true,
            confirmButtonText: "SI",
            cancelButtonText: "NO",
            reverseButtons: true,
        }).then((result) => {
            if (result.value) {
                ActualizarInventariosIniciales();
            }
        });
    };

    const ActualizarInventariosIniciales = async () => {
        try {
            const datos = {
                fecha_inicial: dateToDayStart(fechaInicial),
                almacenes: almacenes.map((item) => ({
                    almacen_id: item.almacen_id,
                    kg_secos_laboratorio: item.kg_secos_laboratorio || 0,
                    kg_secos_liquidacion: item.kg_secos_liquidacion || 0,
                })),
            };
            await upsertInventariosIniciales(datos);
            NotificationManager.success(
                "Inventario actualizado correctamente",
                "Éxito",
                3000,
            );
            regresar && regresar();
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al actualizar el inventario",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const handleChange = (almacenId, field, value) => {
        setAlmacenes((prev) =>
            prev.map((item) =>
                item.almacen_id === almacenId
                    ? { ...item, [field]: value, _dirty: true }
                    : item,
            ),
        );
    };

    return (
        <div className="inventario-inicial__tab-wrapper">
            <CardEmpty noShadow>
                <LoadMask loading={cargando} blur>
                    <div className="inventario-inicial__table-header">
                        <div >
                            <div className="formulario-field">
                                <label htmlFor="fecha_inicial" className="m-0">
                                    Acopio
                                </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={nombreAcopio}
                                    disabled
                                />
                            </div>
                        </div>

                        <div className="ml-auto">
                            <div className="formulario-field">
                                <label htmlFor="fecha_inicial" className="m-0">
                                    Fecha inicial
                                </label>
                                <DatePicker
                                    selected={fechaInicial}
                                    onChange={(date) => {
                                        setFechaInicial(date);
                                    }}
                                    showPopperArrow={false}
                                    dateFormat="DD/MM/YYYY"
                                    placeholderText="Fecha inicial"
                                />
                            </div>
                        </div>
                    </div>

                    <AlmacenesTable
                        almacenes={almacenes}
                        handleChange={handleChange}
                    />

                    <div
                        className="d-flex justify-content-center my-4"
                        style={{ gap: "1rem" }}
                    >
                        {regresar && (
                            <button
                                className="btn btn-outline-dark"
                                onClick={regresar}
                            >
                                Regresar
                            </button>
                        )}
                        <button
                            className="btn btn-primary"
                            onClick={ValidateAndSubmit}
                        >
                            Guardar
                        </button>
                    </div>
                </LoadMask>
            </CardEmpty>
        </div>
    );
};
